import React from "react";
import SignIn from "./SignIn";
import LogOut from "./LogOut";
import { auth } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import "./nav.css";

const style = {
  navbarContainer: `bg-gray-800 p-4 rounded-lg w-[728px]`,
  navbar: `flex justify-between items-center`,
  heading: `text-white text-3xl`,
};

const Navbar = () => {
  const [user] = useAuthState(auth);
  console.log(user);
  return (
    <div className="headh">
      <div className={style.navbarContainer}>
        <div className={style.navbar}>
          <h1 className={style.heading}>chatApp</h1>
          {user ? <LogOut /> : <SignIn />}
        </div>
      </div>
      {/* Add additional spacing below the navbar */}
      <div className="mt-20">
        {/* Your content here */}
      </div>
    </div>
  );
};

export default Navbar;
